import React from 'react';
import { Page } from 'components/shared/Page/Page';
import Router from '@alltrails/shared/components/ReactRouter';
import usePathname from 'hooks/usePathname';
import { Context } from '@alltrails/shared/types/context';
import * as styles from './styles/styles.module.scss';
import AboutContent from './AboutContent';

type AboutProps = {
  context: Context;
};

const About = ({ context }: AboutProps): JSX.Element => {
  const fullpath = usePathname();
  return (
    <div className={styles.pageContainer}>
      <Page context={context}>
        <Router fullpath={fullpath}>
          <AboutContent context={context} />
        </Router>
      </Page>
    </div>
  );
};

export { About as default, AboutProps };
